import React from 'react';
import { Label } from '../Type';
import { useFieldRegistry } from '../Form/FieldRegistry';
import { any, bool, elementType, node, shape, string } from 'prop-types';
export default function FormLabel(props) {
    const { label, name, required = false, id, value, fieldConfig, labelComponent = 'label' } = props;
    const { renderAfterLabel } = useFieldRegistry();
    if (label) {
        return (React.createElement("div", { className: 'kal-form-label-container' },
            React.createElement(Label, { htmlFor: labelComponent === 'label' ? id : null, Component: labelComponent },
                required && React.createElement("span", { className: 'kal-required-asterisk' }, "*"),
                label),
            renderAfterLabel &&
                renderAfterLabel(Object.assign({ name,
                    value }, fieldConfig))));
    }
    return false;
}
FormLabel.propTypes = {
    label: node,
    name: string,
    required: bool,
    id: string,
    value: any,
    fieldConfig: shape({}),
    labelComponent: elementType,
};
//# sourceMappingURL=FormLabel.js.map